"use client"

import { Pin } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PinIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PinIcon = component(Icon)({ as: Pin })
